<template>
  <PubPage showProject @changeProject="changeProject">
    <BasicTable
      :columns="columns"
      bordered
      :dataSource="list"
      :loading="loading"
      boxShadow
      :pagination="{
        current: form.paging.page,
        pageSize: form.paging.limit,
        total: pageTotal,
      }"
      @searchBack="searchBack"
      @pagesChange="pagesChange"
    >
      <template #tableTitle>
        <div class="pub-tableTitle-button">
          <a-button
            type="primary"
            class="btn-blue"
            icon="plus-circle"
            @click="add('add')"
            >添加班级</a-button
          >
        </div>
      </template>
      <template slot="index" slot-scope="{ index }">
        {{ index + 1 }}
      </template>
      <template slot="status" slot-scope="{ record }">
        <PubEnableStatus :status="record.status" />
      </template>

      <template slot="options" slot-scope="{ record }">
        <div class="pub-options">
          <a @click="add('edit', record)"> <a-icon type="form" />编辑 </a>
          <a @click="deleteCustomer(record.id)" class="red">
            <a-icon type="delete" />删除
          </a>
        </div>
      </template>
    </BasicTable>
    <AddModal ref="addModalModal" @ok="moduleOk" />
  </PubPage>
</template>

<script>
import { Classlist } from "@/api";
import AddModal from "./AddModal.vue";
export default {
  components: {
    AddModal,
  },
  data() {
    const columns = [
      {
        title: "序号",
        dataIndex: "index",
        align: "center",
        width: 50,
        hideInSearch: true,
        scopedSlots: true,
      },
      {
        title: "年级班级",
        dataIndex: "name",
      },
      {
        title: "创建时间",
        dataIndex: "createTime",
        align: "center",
        hideInSearch: true,
        width: 150,
      },
      {
        title: "修改时间",
        dataIndex: "updateTime",
        align: "center",
        hideInSearch: true,
        width: 150,
      },
      {
        title: "状态",
        dataIndex: "status",
        width: 100,
        align: "center",
        scopedSlots: true,
        valueType: "select",
        fieldProps: {
          placeholder: "请选择状态",
          option: () => this.common.findSysCodeType("SYS_STATUS"),
        },
      },
      {
        title: "排序",
        dataIndex: "classSort",
        align: "center",
        hideInSearch: true,
        width: 100,
      },
      {
        title: "操作",
        align: "center",
        width: 130,
        dataIndex: "options",
        hideInSearch: true,
        scopedSlots: true,
      },
    ];
    return {
      form: {
        paging: {
          page: 1,
          limit: 20,
          sort: [
            {
              property: "createTime",
              direction: "ASC",
            },
          ],
        },
      },
      list: [],
      pageTotal: 0,
      loading: false,
      columns,
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 切换学校
    changeProject() {
      this.form.schoolId = this.$store.state.user.schoolId;
      this.form.paging.page = 1;
      this.columns = [...this.columns];
      this.getList();
    },
    // 获取数据
    getList() {
      this.loading = true;
      Classlist.gradeClassPage(this.form).then(res => {
        if (res.code == this.config.pubCode) {
          this.list = res.data;
          this.pageTotal = res.total;
        }
        this.loading = false;
      });
    },
    // 翻页回调
    pagesChange(data) {
      this.form.paging.page = data.current;
      this.form.paging.limit = data.pageSize;
      this.getList();
    },
    // 搜索回调
    searchBack(data) {
      data.paging = {
        page: 1,
        limit: this.form.paging.limit,
      };
      this.form = { ...this.form, ...data };
      this.getList();
    },
    // 删除
    deleteCustomer(id) {
      this.pubMsg.confirm("是否确定删除此数据？").then(() => {
        this.loading = true;
        Classlist.gradeClassDelete({ ids: id }).then(res => {
          if (res.code == this.config.pubCode) {
            this.pubMsg.tipMessage("删除成功！", "success");
            this.getList();
          }
          this.loading = false;
        });
      });
    },

    add(type, data) {
      this.$refs.addModalModal.open(type, data);
    },
    moduleOk(data) {
      if (data) {
        this.getList();
      }
    },
  },
};
</script>
